import mixpanel from "mixpanel-browser";
import { config } from "../configs";

const MIXPANEL_TOKEN = config.REACT_APP_MIXPANEL_TOKEN || "";
const ENV = config.REACT_APP_ENVIRONMENT;

if (!MIXPANEL_TOKEN) {
  console.error(
    "Mixpanel token is missing. Analytics will not be initialized."
  );
}

mixpanel.init(MIXPANEL_TOKEN, {
  debug: ENV === "development",
});

const Mixpanel = {
  identify: (userId) => {
    mixpanel.identify(userId);
  },

  track: (event, props) => {
    mixpanel.track(event, {
      action_source: "admin",
      ...props,
    });
  },

  reset: () => {
    mixpanel.reset();
  },
};

export default Mixpanel;
